export class ConfigurationSettingsConfig {
  public static EndPoint = {
    Organization: {
      getOrganizationList: '/platform/page-designer/page/organization/all',
      getOrganization:
        '/platform/page-designer/page/organization/{orgId}?returnUserPage=false&excludeNoActiveVersionPages=true'
    },
    Page: {
      getPage: '/page'
    },
    Asset: {
      getAsset: 'asset',
      getPageAsset: '/platform/page-designer/asset/getpagebyid',
      getUserAsset: '/platform/page-designer/asset/getUserAssets',
      getRoleAsset: '/platform/page-designer/asset/getRoleAssets',
      getPolicyGroupAsset: '/platform/page-designer/asset/getPolicyGroupAssets'
    },
    User: {
      getUser: '/org/user/',
      getUserList: '/org/user/all',
      getUserorgList: '/org/user/organization/'
    },
    ConfigSettings: {
      saveConfig: '/org/config-settings/create',
      getConfigList: '/org/config-settings/list',
      getConfigById: '/org/config-settings/list?id=',
      deleteConfig: '/org/config-settings/',
      updateConfig: '/org/config-settings/',
      registrationInfo: '/org/auth/configsettings',
      datetimeFomrat: '/platform/master/lookup/lookupbycategoryname/DATETIME_FORMAT',
      getConfigurationsByOrgId: '/org/config-settings/listbyOrgId/'
    },
    role: {
      getAllUserRole: '/access-control/role',
      createRole: '/access-control/role/create',
      getLandingPage: '/platform/menu/application',
      addPolicyGroup: '/access-control/role',
      getAllOrgRole: '/access-control/role/organization/{orgid}',
      dossier: '/dossier'
    },
    Email: {
      emailtemplateList: '/solution/emailtemplate/channel/EMAIL'
    },
    org: {
      getOrganizations: '/org/management-group/organization/tree'
    },
    Attachments: {
      GetAttachmentReferral: '/ref/attachment/referral',
      GetCategoryLookup: '/platform/master/lookup/lookupbycategoryname',
      UploadKey: '/common/files/upload-key',
      DownloadKey: '/common/files/download-key',
      PostAttachment: '/ref/attachment/create',
      PutAttachment: '/ref/attachment'
    }
  };
}
